export const MAIN_LAYOUT = {
  HEADER: {
    TIPS: 'Tips',
    LOGOUT: 'Sign out',
    NOTIFICATIONS: 'Notifications',
  },
}

export const ADMIN = 'Admin'
